import React, { useState } from 'react';
import { Typography, Button, Callout } from 'seagull';
import { useStoreActions } from "../../contexts";
import plaidLogo from "./plaid-logo-horizontal-RGB.png";
import styles from "./ConnectPlaid.module.scss";
import { PlaidMode, usePlaidState } from "../../hooks/usePlaidState";
import { Intent } from "../../infra/access-control";
import { RelationshipProgressStatus } from "../../models/relationship";
import { mapErrorToMessage } from "./errors";
/** Renders a UI that starts connects a bank account via plaid. */
export default function ConnectPlaid(props) {
  const {
    disabledReason,
    relationshipId,
    updateProgress,
    vendorId,
    onConnect
  } = props;
  const {
    logBI,
    api
  } = useStoreActions();
  const [errorMessage, setErrorMessage] = useState(null);
  const plaidLink = usePlaidState({
    mode: {
      type: PlaidMode.Customer,
      vendorId,
      relationshipId
    },
    onSuccess(account) {
      const fundingSourceId = account.id;
      if (updateProgress) {
        api.relationship.updateProgressStatus(relationshipId, RelationshipProgressStatus.PaymentMethod);
      }
      logBI(10807);
      onConnect(fundingSourceId);
    },
    onError(error) {
      setErrorMessage(mapErrorToMessage(error));
    }
  });
  return /*#__PURE__*/React.createElement("form", {
    "data-testid": "manage-payment-methods-connect-plaid-form",
    onSubmit: event => {
      event.preventDefault();
      logBI(10805);
      setErrorMessage(null);
      plaidLink.open();
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1"
  }, "Securely add your bank account via Plaid."), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1"
  }, "Connect instantly using your bank credentials or using your routing and account numbers."), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.plaidLogo,
    src: plaidLogo,
    alt: "Plaid logo"
  }), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    size: "small",
    disabled: !!disabledReason,
    "data-testid": "manage-payment-methods-connect-plaid",
    intent: Intent.AddPaymentMethod,
    tooltip: disabledReason ? {
      placement: 'top',
      title: /*#__PURE__*/React.createElement("div", {
        "data-testid": "connect-plaid-disabled-reason"
      }, disabledReason)
    } : undefined
  }, "Connect bank account")), errorMessage && /*#__PURE__*/React.createElement(Callout, {
    className: styles.error,
    intent: "error",
    "data-testid": "manage-payment-methods-plaid-error"
  }, errorMessage));
}